export default {
      id: "maximize-usage",
      viewBox: "0 0 17 17",
      url: __webpack_public_path__ + "sprite-46b249.svg#maximize-usage",
      toString: function () {
        return this.url;
      }
    }